/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SpecimenProtocolOverride = {
    protocol: SpecimenProtocolOverride.protocol;
    active: boolean;
}

export namespace SpecimenProtocolOverride {

    export enum protocol {
        DIF = 'dif',
        ALOPECIA = 'alopecia',
        WHOLE_SPECIMEN = 'whole_specimen',
        NAIL = 'nail',
        PASH_REFLEX = 'pash_reflex',
        SLOW_MOHS = 'slow_mohs',
    }


}
